<template>
  <div>
    <div class="blurb-and-subscription-container w-100 py-5">
      <div class="blurb-and-subscription">
        <div class="display-flex align-center justify-space-between gap-8">
          <div class="blurb-container">
            <div class="white--text font-space-grotesk font-weight-500 text-50">
              Go Ad-Free
              <br />
              Empower Artists
            </div>
          </div>
          <div class="subscription-container">
            <div class="subscription-plan bg-white">
              <div class="d-flex justify-center align-center tab-group">
                <div
                  v-for="(item, i) in tabList"
                  :key="i"
                  @click="setTab(item.id)"
                  class="tab-text width-50 cursor-pointer text-center"
                  :class="{ 'active-tab': item.id == tab }"
                >
                  {{ item.title }}
                </div>
              </div>

              <div v-if="categoryPlan == 'creator'" class="font-space-grotesk">
                <div class="text-31 font-weight-700 mb-1">
                  {{ creators.title }}
                  <span class="price-text">{{ tab === "yearly" ? "$10/mo" : "$12/mo" }}</span>
                </div>
                <div class="text-grey-purple-1 text-16 font-weight-500 mb-4">
                  {{ creators.subtitle }}
                </div>
                <div
                  v-for="(item, i) in creators.option"
                  :key="i"
                  class="d-flex align-center justify-start gap-10 pb-2"
                >
                  <div class="max-w-18px d-flex justify-center">
                    <img
                      src="../../../assets/check-icon-black.svg"
                      aspect-ratio="1"
                      height="18"
                      width="18"
                    />
                  </div>
                  <span class="font-poppins text-14 font-weight-500">
                    {{ item }}
                  </span>
                </div>
                <v-btn
                  block
                  text
                  class="package-card-btn font-weight-700 mt-3"
                  @click="handleGetStarted"
                >
                  Get Started
                </v-btn>
              </div>
              <div v-else class="font-space-grotesk">
                <div class="text-31 font-weight-700 mb-1">
                  {{ premium.title }}
                  <span class="price-text">{{ tab === "yearly" ? "$100/mo" : "$12/mo" }}</span>
                </div>
                <div class="text-grey-purple-1 text-16 font-weight-500 mb-4">
                  {{ premium.subtitle }}
                </div>
                <div
                  v-for="(item, i) in premium.option"
                  :key="i"
                  class="d-flex align-center justify-start gap-10 pb-2"
                >
                  <div class="max-w-18px d-flex justify-center">
                    <img
                      src="../../../assets/check-icon-black.svg"
                      aspect-ratio="1"
                      height="18"
                      width="18"
                    />
                  </div>
                  <span class="font-poppins text-14 font-weight-500">
                    {{ item }}
                  </span>
                </div>
                <v-btn
                  block
                  text
                  class="package-card-btn font-weight-700 mt-3"
                  @click="handleGetStarted"
                >
                  Coming soon
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="dialog"
      content-class="bg-grey-white upgrade-plan-dialog"
      fullscreen
      @click.self="closeDialog"
    >
      <div class="d-flex justify-center align-center full-height">
        <div
          class="display-flex justify-center align-start gap-14 subscription-div"
          @click.stop
        >
          <div class="upgrade-plan-dialog">
            <div
              class="display-flex justify-center align-center logo-container"
            >
              <img
                :src="require('@/assets/ys_logo_primary-black.svg')"
                aspect-ratio="1"
                height="24"
                width="124"
                class="logo-img"
              />
            </div>
            <div class="subscription-plan upgrade-plan-dialog__content">
              <div class="d-flex justify-center align-center tab-group">
                <div
                  v-for="(item, i) in tabList"
                  :key="i"
                  @click="setTab(item.id)"
                  class="tab-text width-50 cursor-pointer text-center"
                  :class="{ 'active-tab': item.id == tab }"
                >
                  {{ item.title }}
                </div>
              </div>

              <div class="credit-card bg-white mb-4">
                <div class="font-inter text-20 font-weight-700">PREMIUM</div>
                <div class="font-inter text-16 font-weight-500">
                  All access for everyone.
                </div>
                <div class="display-flex align-center font-space-grotesk">
                  <span class="text-36 font-weight-700">
                    ${{ tab === "yearly" ? 100 : 12 }}
                  </span>
                  <span class="text-14 font-weight-500 text-grey-3 mt-2">
                    /year
                  </span>
                </div>
              </div>

              <div class="credit-card">
                <div class="text-dmsans-14 mb-3">
                  <template v-if="tab === 'yearly'">
                    Your card will be charged $100 each year starting today.
                  </template>
                  <template v-else>
                    Your card will be charged $12 each month starting today.
                  </template>
                </div>
                <hr class="divider mb-4" />
                <div
                  class="display-flex align-center justify-space-between mb-3"
                >
                  <div class="text-dmsans-14 font-weight-700 mb-2">
                    Credit card
                  </div>

                  <div class="display-flex align-center gap-8">
                    <img
                      src="../../../assets/mobile/icon/visa.svg"
                      width="24"
                      height="16"
                    />
                    <img
                      src="../../../assets/mobile/icon/master-card.svg"
                      width="24"
                      height="16"
                    />
                    <img
                      src="../../../assets/mobile/icon/american-express.svg"
                      width="24"
                      height="16"
                    />
                    <img
                      src="../../../assets/mobile/icon/discover.svg"
                      width="24"
                      height="16"
                    />
                  </div>
                </div>
                <div class="credit-card__input bg-white">
                  <div
                    class="display-flex align-center px-3 credit-card__number"
                  >
                    <div id="card-element" class="StripeElement"></div>
                  </div>
                </div>
                <v-btn
                  @click="purchase"
                  class="text-poppins text-18 font-weight-600 white--text w-100 bg-blue-1 btn-pay"
                >
                  Purchase
                </v-btn>

                <div class="font-dm-sans text-center">
                  <span class="text-16"> Powered by </span>
                  <span class="text-20 font-weight-700">stripe</span>
                </div>
              </div>
            </div>
          </div>
          <v-icon
            class="material-icons icon icon-close cursor-pointer icon--x-large"
            @click="closeDialog"
          >
            close
          </v-icon>
        </div>
      </div>
    </v-dialog>

    <v-dialog
      v-model="successDialog"
      content-class="bg-grey-white upgrade-plan-dialog"
      fullscreen
      @click.self="closeSuccessDialog"
    >
      <v-icon
        class="material-icons icon icon-close cursor-pointer icon--x-large"
        @click="closeSuccessDialog"
      >
        close
      </v-icon>
      <div
        class="bg-grey-white h-100 w-100 display-flex justify-center align-center"
      >
        <div class="success-dialog-content">
          <div
            class="bg-white success__content mt-5 font-poppins display-flex flex-column align-center justify-center"
          >
            <img
              :src="require('@/assets/ys_logo_primary-black.svg')"
              aspect-ratio="1"
              height="24"
              width="124"
              class="mb-5 text-center w-100 logo-img"
            />
            <img
              src="/static/images/user.png"
              aspect-ratio="1"
              height="150"
              width="150"
              class="user-img"
            />

            <div class="thank-you-text text-24 font-weight-700">Thank you,</div>
            <div
              class="thank-you-text text-24 font-weight-700 display-flex align-center"
            >
              <span v-if="currentUser">{{ currentUser.first_name }}</span>
              <img
                src="/static/images/ic_circle_check.svg"
                aspect-ratio="1"
                height="15"
                width="15"
                class="check-icon"
              />
            </div>
            <div class="my-3 text-16 font-weight-500">
              Your subscription is active!
            </div>
            <v-btn
              @click="goToDashboard"
              class="btn-dashboard white--text font-weight-700 text-14 mt-3"
            >
              Go to dashboard
            </v-btn>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>



<script>
import { mapGetters } from "vuex";
import { loadStripe } from "@stripe/stripe-js";

export default {
  props: {
    categoryPlan: { type: String },
  },
  data() {
    return {
      dialog: false,
      successDialog: false,
      tab: "yearly",
      tabList: [
        { id: "yearly", title: "Yearly (Save 20%)" },
        { id: "monthly", title: "Monthly" },
      ],
      creators: {
        title: "Premium",
        subtitle: "All access for everyone!",
        option: [
          "Ad Free",
          "Unlimited Streaming",
          "See Creators You Support",
          "Offline Listening",
          "Human powered algorithm",
          "Fair Streaming Payouts (for artists)",
          "Analytics (for artists)",
        ],
      },
      premium: {
        title: "Premium",
        subtitle: "All access for everyone. Cancel anytime.",
        option: [
          "Unlimited uploads",
          "Analytics for all content",
          "Unlimited streaming",
          "Offline listening",
          "No Ads",
        ],
      },
      stripe: null,
      elements: null,
      cardElement: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "currentUser"]),
  },
  methods: {
    setTab(tab) {
      this.tab = tab;
    },
    openDialog() {
      if (!this.isAuthenticated) {
        this.$store.dispatch("auth/setRedirectPath", "upgrade");
        this.$router.push({ name: "login" });
      } else {
        this.dialog = true;
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    closeSuccessDialog() {
      this.successDialog = false;
    },
    async purchase() {
      try {
        const { token, error } = await this.stripe.createToken(
          this.cardElement
        );
        if (error) {
          console.error("Stripe token creation error:", error);
          alert(error.message);
          return;
        }

        const response = await this.$http.post("/v2/subscriptions", {
          token: token.id,
          plan: this.tab === "yearly" ? "yearly_plan_id" : "monthly_plan_id",
        });

        if (response.status === 200) {
          this.dialog = false;
          this.successDialog = true;
        } else {
          console.error("Backend error:", response.data);
          alert("An error occurred while processing your payment.");
        }
      } catch (err) {
        console.error("Error processing payment:", err);
        alert("An error occurred while processing your payment.");
      }
    },
    goToDashboard() {
      this.$router.push({ name: "dashboard" });
    },
    handleGetStarted() {
      // if (!this.isAuthenticated) {
      //   this.$store.dispatch("auth/showLoginModal", {
      //     redirect: "subscriptionModal",
      //   });
      // } else {
        this.dialog = true;
      // }
    },
  },
  async mounted() {
    this.stripe = await loadStripe(process.env.STRIPE_PUBLISHABLE_KEY);
    this.elements = this.stripe.elements();
    this.cardElement = this.elements.create("card");
    this.cardElement.mount("#card-element");
  },
  created() {
    if (
      this.$store.state.auth.redirectPath === "upgrade" &&
      this.isAuthenticated
    ) {
      this.dialog = true;
      this.$store.dispatch("auth/setRedirectPath", null);
    }
  },
};
</script>

<style lang="scss" scoped>
.max-w-18px {
  max-width: 18px;
}

.package-card-btn {
  background: #4f56ff !important;
  color: #fff;
  min-height: 47px;
  border-radius: 56px;
  margin-bottom: 20px;
  font-size: 18px;
}

.upgrade-plan-dialog {
  box-shadow: 0px 4px 24px 0px #0000000f;
  background: #f0f2f4;
  border-radius: 30px;
  padding: 24px;
  &__content {
    border: 0px !important;
  }
}

.credit-card {
  border-radius: 20px;
  background: #f9f9f9;
  padding: 16px;

  &__input {
    border-radius: 8px;
    border: 1px solid rgba(60, 66, 87, 0.12);
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.04),
      0px 2px 5px 0px rgba(0, 0, 0, 0.08);
  }

  &__number {
    border-bottom: 1px solid rgba(60, 66, 87, 0.12);
  }
  &__month {
    border-right: 1px solid rgba(60, 66, 87, 0.12) !important;
  }
}

.success {
  &__content {
    border-radius: 20px;
    padding-left: 72px;
    padding-right: 72px;
    padding-top: 12px;
    padding-bottom: 32px;
    text-align: center;
  }
}

.btn-dashboard {
  height: 44px !important;
  background: #000 !important;
  border-radius: 50px;
}

.btn-pay {
  border-radius: 6px;
  height: 45px;
  margin: 26px 0px;
}

.icon-success-dialog {
  position: absolute;
  right: 20px;
  top: 20px; /* Adjusted to be in line with the requirements */
}

.blurb-and-subscription-container {
  margin-top: 42px; /* Adjust this value to move the entire section up or down */
}

.blurb-and-subscription {
  margin-left: 20px; /* Adjust this value to move the entire section left or right */
  margin-right: 20px; /* Adjust this value to move the entire section left or right */
}

.blurb-container {
  margin-bottom: 20px; /* Adjust this value to move the blurb up or down */
  margin-left: -20px;
  margin-top: -124px;
  min-width: 750px;
}

.subscription-container {
  margin-top: -30px; /* Adjust this value to move the subscription section up or down */
}

.divider {
  border: 0;
  height: 1px;
  background-color: #ccc;
  /* Add more custom styles as needed */
}

.text-16 {
  font-size: 18px;
  margin-top: -8px;
}

.text-14 {
  font-size: 15px;
}

.text-24 {
  font-size: 28px;
  letter-spacing: -1px;
}

.gap-10 {
  gap: 12px;
}

.logo-img {
  margin-top: 20px; /* Adjust this value to move the logo up or down */
}

.icon--x-large {
  font-size: 36px;
}

.icon-close {
  position: absolute;
  top: 20px;
  right: 20px;
}

.success-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  margin-top: -150px;
}

.thank-you-text {
  line-height: 1.2; /* Closer line height */
}

.user-img {
  /* You can adjust the size using these properties */
  width: 150px;
  height: 150px;
  margin-bottom: 20px;
}

.check-icon {
  margin-left: 5px; /* Adjust this value to set the desired margin */
}

/* Ensure the Stripe Element is visible */
.StripeElement {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* New CSS class for price text */
.price-text {
  float: right;
  font-size: 28px; /* Adjust font size as needed */
  font-weight: 700;
  color: #000; /* Black text */
  margin-top: 7px;
}

/* Desktop-specific overrides */
@media screen and (min-width: 1281px) {
  .revenue-output-box {
    background-color: transparent; /* or background-color: white; */
  }

  .result-price {
    color: black; /* Ensure text is black for better visibility */
  }

  .result-price-text {
    color: black; /* Ensure text is black for better visibility */
  }

  .btn-create-account {
    display: block;
    margin-top: 50px; /* Ensure it matches the positioning on the other page */
  }
}
</style>



// WEBPACK FOOTER //
// UpgradePlan.vue?5e82a883